// Raw Auth0 role names, as emitted by the backend's `/me` endpoint — used for display and
// RUM tagging only; access is decided by `permissions` and the `vendors` scope.
export const SUPERADMIN_ROLE = 'mpp-superadmin';
export const PARTNER_ROLE = 'mpp-partner';

// Mirrors the backend's PERMISSIONS catalog exactly.
export const PERMISSIONS = {
  READ_CAPACITY: 'read:capacity',
  WRITE_CAPACITY: 'write:capacity',
  READ_PO: 'read:po',
  WRITE_PO: 'write:po',
  IMPORT_CAPACITY: 'import:capacity',
  READ_VENDORS: 'read:vendors',
  WRITE_VENDORS: 'write:vendors',
  WRITE_CAPACITY_TYPES: 'write:capacity-types',
  DELETE_CAPACITY_IMPORTS: 'delete:capacity-imports',
  READ_CUSTOMER_MAPPINGS: 'read:customer-mappings',
  WRITE_CUSTOMER_MAPPINGS: 'write:customer-mappings',
  MANAGE_ACCESS: 'manage:access',
  MANAGE_NOTIFICATIONS: 'manage:notifications',
  READ_PO_ACTIVITY: 'read:po-activity',
  READ_PO_TRACKER: 'read:po-tracker',
  WRITE_PO_SHIPMENTS: 'write:po-shipments',
  REQUEST_PO_DELIVERY: 'request:po-delivery',
  ACCESS_ALL_VENDORS: 'access:all-vendors',
} as const;

// Permissions that are useful without any vendor in scope, so holding one counts as access
// even for a caller mapped to zero vendors.
export const NON_VENDOR_SCOPED: ReadonlySet<string> = new Set<string>([
  PERMISSIONS.READ_VENDORS,
  PERMISSIONS.WRITE_VENDORS,
  PERMISSIONS.WRITE_CAPACITY_TYPES,
  PERMISSIONS.READ_CUSTOMER_MAPPINGS,
  PERMISSIONS.WRITE_CUSTOMER_MAPPINGS,
  PERMISSIONS.MANAGE_ACCESS,
  PERMISSIONS.MANAGE_NOTIFICATIONS,
  PERMISSIONS.READ_PO_ACTIVITY,
]);

export interface MeVendor {
  id: string;
  name: string;
  alias: string | null;
}

export interface Me {
  email: string;
  // null for any custom Auth0 role; never gate on it.
  role: typeof SUPERADMIN_ROLE | typeof PARTNER_ROLE | null;
  permissions: string[];
  vendors: MeVendor[] | 'all';
}
